var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBunsinessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 0.756836H1.5C1.09 0.756836 0.75 1.09684 0.75 1.50684C0.75 1.91684 1.09 2.25684 1.5 2.25684H1.75V19.5068C1.75 19.9168 2.09 20.2568 2.5 20.2568H17.5C17.91 20.2568 18.25 19.9168 18.25 19.5068V2.25684H18.5C18.91 2.25684 19.25 1.91684 19.25 1.50684C19.25 1.09684 18.91 0.756836 18.5 0.756836ZM16.75 10.7568H13.25V7.25684H16.75V10.7568ZM11.75 10.7568H8.25V7.25684H11.75V10.7568ZM3.25 10.7568V7.25684H6.75V10.7568H3.25ZM8.25 5.75684V2.25684H11.75V5.75684H8.25ZM6.75 2.25684V5.75684H3.25V2.25684H6.75ZM7.25 18.7568V15.5068C7.25 15.3668 7.36 15.2568 7.5 15.2568H9.25V18.7568H7.25ZM10.75 18.7568V15.2568H12.5C12.64 15.2568 12.75 15.3668 12.75 15.5068V18.7568H10.75ZM14.25 18.7568V15.5068C14.25 14.5468 13.46 13.7568 12.5 13.7568H7.5C6.54 13.7568 5.75 14.5468 5.75 15.5068V18.7568H3.25V12.2568H16.75V18.7568H14.25ZM16.75 5.75684H13.25V2.25684H16.75V5.75684Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBunsinessIcon);
export default __webpack_public_path__ + "static/media/bunsiness-icon.d9bc4a8eaba40e3415fb3bbf2ef95bd3.svg";
export { ForwardRef as ReactComponent };